import React,{ useState,useRef } from 'react'
import {
  StyledCard,
  PaddingContainer,
  OuterDiv,
  CenterText,
  CardText1,
  CardText2,
  ContentAlignCenter,
  BottomText,
  StyledCard1,
  CardText3,
  TopHeader,
  TopHeading,
  ChangeText,
  PopupModel,
  PopupText,
  PopupLabel,
  StyledButton,
  FormItem
} from 'modules/DriveDetails/Style/SelectionStyle'
import Flex from 'components/Flex'
import Button from 'components/Button'
import { RoleNameDiv } from 'modules/DriveDetails/Style/style'
import { Radio,Empty,Form } from 'antd'
import TextAreas from 'components/Form/TextArea'
import { StyledSpan } from '../../Dashboard/Style/style'

const DateAndTimeSelection = ({
  slotDate,
  slotTime,
  selectDriveDate,
  ResheduleDriveDate,
  RequestReshedule,
  studentDetails
}) => {
  const [form] = Form.useForm()
  const [isDateSelected, setIsDateSelected] = useState(false)
  const [isTimeSelected, setIsTimeSelected] = useState(false)
  const [activeCard, setActiveCard] = useState()
  const [activeTimeCard, setActiveTimeCard] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [reason, setReason] = useState(null)
  const object = useRef()


  const handleOk = async (value) => {
    let payLoad ={
      candidateReason:  reason === 'OTHER' ? value?.reason : reason,
      candidateStatus: "RESCHEDULE_REQUESTED"
    }
    RequestReshedule(payLoad)
    setIsModalOpen(false)
    
  }
  const handleCancel = () => {
    setIsModalOpen(false)
   // setIsDateSelected(true)
  }

  const handleCardClick = cardId => {
    setActiveCard(cardId)
    setIsDateSelected(true)
    object.current.scrollIntoView({ behavior: 'smooth' })
  }
  const confirmDate = () =>{
    let data ={ 
      date: activeCard,
      time: activeTimeCard
    }
    selectDriveDate(data)
  }
  const checkDateSlot = inputDate => {
    const dateObj = new Date(inputDate);
    
    // Step 3: Get the day of the month (e.g., "28")
    const dayOfMonth = dateObj.getDate();
    const year = dateObj.getFullYear();
    // Step 4: Get the abbreviated month name (e.g., "Jul")
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthName = months[dateObj.getMonth()];
    
    // Step 5: Combine the day and month name in the desired format "28 Jul"
    const formattedDate = `${dayOfMonth.toString().padStart(2, '0')} ${monthName} ${year}`;

    return formattedDate
  }
  const checkDateSlot1 = inputDate =>{
    const dateObj = new Date(inputDate);
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const dayOfWeek = daysOfWeek[dateObj.getDay()];
    return dayOfWeek
  }
  const handleCardTimeClick = cardId => {
    setActiveTimeCard(cardId)
    setIsTimeSelected(true)
  }
  const OnClickPopup = () => {
    setIsModalOpen(true)
  }
  const clearAll = () =>{
    setIsDateSelected(false)
    setIsTimeSelected(false)
    setActiveCard(null)
    setActiveTimeCard(null)
  }
  const clearTime = () =>{
    setIsTimeSelected(false)
    setActiveTimeCard(null)
  }
  const onChageType = e => { 
   setReason(e.target.value)

  }

  return (
    <PaddingContainer>
      {(!isDateSelected || !isTimeSelected) && (
        
          <OuterDiv>
            <CenterText>Select Date</CenterText>
            {slotDate === undefined &&    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
            <Flex wrap>
              {slotDate?.map((Item, index) => (
                <StyledCard
                  key={Item}
                  onClick={() => handleCardClick(Item)}
                  styleProps={activeCard === Item}
                >
                  <CardText1 styleProps={activeCard === Item} >
                    {' '}
                    {checkDateSlot(Item)}
                  </CardText1>
                  <CardText2 styleProps={activeCard === Item}>
                    {' '}
                    {checkDateSlot1(Item)}
                  </CardText2>
                </StyledCard>
              ))}
            </Flex>
          </OuterDiv>
      )}
        <br></br>
      {isDateSelected && !isTimeSelected  && (
      
          <OuterDiv>
            <CenterText>Select a time slot</CenterText>
            <Flex wrap>
            

{slotTime?.map((Item, index) => (
                <StyledCard1
                  key={Item}
                  onClick={() => handleCardTimeClick(Item)}
                  styleProps={activeTimeCard === Item}
                >
                  <CardText3 styleProps={activeTimeCard === Item} >
                    {' '}
                    {Item}
                  </CardText3>
                  
                </StyledCard1>
              ))}
            </Flex>
          </OuterDiv>

      )}
      {isDateSelected && isTimeSelected && (
        <>
          <OuterDiv>
            <TopHeader row spaceBetween alignCenter>
              <TopHeading flexStart>Date of Interview - {checkDateSlot(activeCard)}</TopHeading>
              <ChangeText onClick={clearAll}>Change Date</ChangeText>
            </TopHeader>
          </OuterDiv>
          <br></br>
          <OuterDiv>
            <TopHeader row spaceBetween alignCenter>
              <TopHeading flexStart>Time of Interview - {activeTimeCard}</TopHeading>
              <ChangeText onClick={clearTime}>Change Time</ChangeText>
            </TopHeader>
          </OuterDiv>
          <br></br>
          <ContentAlignCenter>
            <Button.Secondary text={'Go Back'} onClick={clearAll} />
            &nbsp; &nbsp; &nbsp;
            <Button.Primary text={'Confirm'} onClick={confirmDate} />
          </ContentAlignCenter>
 
        </>
      )}
          <ContentAlignCenter ref={object}>
            <BottomText>
              Not available on these dates?<StyledSpan onClick={OnClickPopup}> Please let us know</StyledSpan>
            </BottomText>
          </ContentAlignCenter>
      {isModalOpen && (
        <PopupModel open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
        footer = {[
          <div style={{display:'flex', justifyContent: 'flex-end'}} key={'popup'}>

          <Button.Secondary text="Cancel" onClick={handleCancel} />,
          <Button.Primary text="Submit" onOk={handleOk} htmlType={'submit'} form={'reasonForm'}/>
          </div>
        ]}
        >
          <RoleNameDiv>Hello {studentDetails?.admin?.firstName}</RoleNameDiv>
          <PopupText>
            Would you take a moment and tell us the reason for not available in
            a these dates.{' '}
          </PopupText>
      
          <Form
          scrollToFirstError
          onFinish={handleOk}
          id={'reasonForm'}
          form={form}
        >
              <PopupLabel>Reason:</PopupLabel>
              <FormItem
              name="type"
              rules={[
                {
                  required: true,
                  message: 'Please Choose Reason!',
                },
              ]}
            >
          <Radio.Group onChange={onChageType}>
            <StyledButton boxed={true} label="Having exams"   value={'Having exams'}/>

            <StyledButton boxed={true} label="Having other interviews"   value={'Having other interviews'}/>
                 
            <StyledButton boxed={true} label="Other (Mention the reason below)"  value={'OTHER'} />

          </Radio.Group>
          </FormItem>
          { reason === 'OTHER' &&
          <>
          <PopupLabel>Metion the Reason *</PopupLabel>
          <br></br>
          <TextAreas  
             name={'reason'}
             rules={[
               {
                 required: true,
                 message: 'Please enter the reason!',
               },
             ]}
             required
          placeholder="Reason for Cancel" />
</>
}
          </Form>
        </PopupModel>
      )}
    </PaddingContainer>
  )
}

export default DateAndTimeSelection
